import { render } from "./dialogadd.vue?vue&type=template&id=9f9b6800&scoped=true"
import script from "./dialogadd.vue?vue&type=script&lang=js"
export * from "./dialogadd.vue?vue&type=script&lang=js"

import "./dialogadd.vue?vue&type=style&index=0&id=9f9b6800&scoped=true&language=stylus&rel=stylesheet%2Fstylus&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9b6800"]])

export default __exports__